import classNames from "classnames";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

import { ROUTES } from "src/config/constants";
import { AccountResponse } from "src/core/models/auth";

import actionsCSS from "./Actions.module.css";

const MobileUserActions = ({
  user,
  handleUser,
  setRef,
}: {
  user: AccountResponse | undefined;
  handleUser: (userId: number | undefined) => void;
  setRef: (key: number, refElem: any) => void;
}) => {
  let location = useLocation();
  let isActiveRoute = location.pathname.includes("aktivni");

  return (
    <div className={classNames("u-block", "u-pos-fixed", "u-z-index10", "u-w100", "u-h100 ", "u-bg-black", "u-bg-black-light", actionsCSS.mobileActionCont)}>
      <div ref={(refElem) => setRef(0, refElem)} className={classNames("u-h8", actionsCSS.mobileAction)}>
        <div className={actionsCSS.rectangleH}></div>
        <div className="u-flex u-flex-content-center u-mt10px u-pb10px u-mb20px u-borderSecLight u-w100">
          <h6 className="u-t-f16p u-t-lh15 u-t-secondary u-t-w400 u-t-uppercase u-m0">Opcije</h6>
        </div>
        <div className="u-flex u-col-12 u-flex-items-center u-flex-column">
          {isActiveRoute && (
            <Link
              to={ROUTES.showAdminUserProjects(user?.id)}
              className="u-t-valign-mid u-mb20px u-font-family-inh u-t-f16p u-t-lh15 u-t-black u-t-nodecoration u-t-w400 u-cursor-pointer"
            >
              Poslani upiti
            </Link>
          )}
          <div onClick={() => handleUser(user?.id)} className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer">
            {isActiveRoute ? "Blokiraj korisnika" : "Ponovo aktiviraj korisnika"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileUserActions;
